<div class="page-header">
	<md-header size="lg" variant="semibold">{{ pageTitle() }}</md-header>

	@if (isBeta()) {
		<lb-beta-tag></lb-beta-tag>
	}
</div>
@if (pageSubtitle()) {
	<md-header size="md" variant="semibold">{{ pageSubtitle() }}</md-header>
}
